import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Payment.css'

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null)

  const handleSubmit = async (event) => {
    // Block native form submission.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement);

    // Use your card Element with other Stripe.js APIs
    const {error, paymentMethod} = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      setError(error);
    } else {
      console.log(paymentMethod);
    }
  };

  console.log(error)
  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <CardElement />

    </form>
  );
};

export default CheckoutForm